/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AttachDocumentsCommand,
  GetApiV1VolunteersParams,
  MembershipCardDto,
  ProblemDetails,
  RegisterVolunteerCommand,
  ReviewVolunteerRequest,
  ValidationProblemDetails,
  VolunteerDocumentsDto,
  VolunteerSummaryDtoPagedList
} from '.././model';

import { request } from '../../http-client';




export const postApiV1VolunteersRegister = (
    registerVolunteerCommand: RegisterVolunteerCommand,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/volunteers/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerVolunteerCommand, signal
    },
      );
    }
  


export const getPostApiV1VolunteersRegisterMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1VolunteersRegister>>, TError,{data: RegisterVolunteerCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1VolunteersRegister>>, TError,{data: RegisterVolunteerCommand}, TContext> => {

const mutationKey = ['postApiV1VolunteersRegister'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1VolunteersRegister>>, {data: RegisterVolunteerCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1VolunteersRegister(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1VolunteersRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1VolunteersRegister>>>
    export type PostApiV1VolunteersRegisterMutationBody = RegisterVolunteerCommand
    export type PostApiV1VolunteersRegisterMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1VolunteersRegister = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1VolunteersRegister>>, TError,{data: RegisterVolunteerCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1VolunteersRegister>>,
        TError,
        {data: RegisterVolunteerCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1VolunteersRegisterMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1Volunteers = (
    params?: GetApiV1VolunteersParams,
 signal?: AbortSignal
) => {
      
      
      return request<VolunteerSummaryDtoPagedList>(
      {url: `/api/v1/volunteers`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1VolunteersQueryKey = (params?: GetApiV1VolunteersParams,) => {
    return [
    `/api/v1/volunteers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1VolunteersQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Volunteers>>, TError = unknown>(params?: GetApiV1VolunteersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Volunteers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1VolunteersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Volunteers>>> = ({ signal }) => getApiV1Volunteers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Volunteers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1VolunteersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Volunteers>>>
export type GetApiV1VolunteersQueryError = unknown


export function useGetApiV1Volunteers<TData = Awaited<ReturnType<typeof getApiV1Volunteers>>, TError = unknown>(
 params: undefined |  GetApiV1VolunteersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Volunteers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Volunteers>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Volunteers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Volunteers<TData = Awaited<ReturnType<typeof getApiV1Volunteers>>, TError = unknown>(
 params?: GetApiV1VolunteersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Volunteers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Volunteers>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Volunteers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Volunteers<TData = Awaited<ReturnType<typeof getApiV1Volunteers>>, TError = unknown>(
 params?: GetApiV1VolunteersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Volunteers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Volunteers<TData = Awaited<ReturnType<typeof getApiV1Volunteers>>, TError = unknown>(
 params?: GetApiV1VolunteersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Volunteers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1VolunteersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiV1VolunteersUserIdReview = (
    userId: string,
    reviewVolunteerRequest: ReviewVolunteerRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/volunteers/${userId}/review`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reviewVolunteerRequest, signal
    },
      );
    }
  


export const getPostApiV1VolunteersUserIdReviewMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1VolunteersUserIdReview>>, TError,{userId: string;data: ReviewVolunteerRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1VolunteersUserIdReview>>, TError,{userId: string;data: ReviewVolunteerRequest}, TContext> => {

const mutationKey = ['postApiV1VolunteersUserIdReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1VolunteersUserIdReview>>, {userId: string;data: ReviewVolunteerRequest}> = (props) => {
          const {userId,data} = props ?? {};

          return  postApiV1VolunteersUserIdReview(userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1VolunteersUserIdReviewMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1VolunteersUserIdReview>>>
    export type PostApiV1VolunteersUserIdReviewMutationBody = ReviewVolunteerRequest
    export type PostApiV1VolunteersUserIdReviewMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1VolunteersUserIdReview = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1VolunteersUserIdReview>>, TError,{userId: string;data: ReviewVolunteerRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1VolunteersUserIdReview>>,
        TError,
        {userId: string;data: ReviewVolunteerRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1VolunteersUserIdReviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1VolunteersMeCard = (
    
 signal?: AbortSignal
) => {
      
      
      return request<MembershipCardDto>(
      {url: `/api/v1/volunteers/me/card`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1VolunteersMeCardQueryKey = () => {
    return [
    `/api/v1/volunteers/me/card`
    ] as const;
    }

    
export const getGetApiV1VolunteersMeCardQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1VolunteersMeCardQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>> = ({ signal }) => getApiV1VolunteersMeCard(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1VolunteersMeCardQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>>
export type GetApiV1VolunteersMeCardQueryError = ProblemDetails


export function useGetApiV1VolunteersMeCard<TData = Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>,
          TError,
          Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1VolunteersMeCard<TData = Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>,
          TError,
          Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1VolunteersMeCard<TData = Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1VolunteersMeCard<TData = Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersMeCard>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1VolunteersMeCardQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiV1VolunteersMeDocuments = (
    attachDocumentsCommand: AttachDocumentsCommand,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/volunteers/me/documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: attachDocumentsCommand, signal
    },
      );
    }
  


export const getPostApiV1VolunteersMeDocumentsMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1VolunteersMeDocuments>>, TError,{data: AttachDocumentsCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1VolunteersMeDocuments>>, TError,{data: AttachDocumentsCommand}, TContext> => {

const mutationKey = ['postApiV1VolunteersMeDocuments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1VolunteersMeDocuments>>, {data: AttachDocumentsCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1VolunteersMeDocuments(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1VolunteersMeDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1VolunteersMeDocuments>>>
    export type PostApiV1VolunteersMeDocumentsMutationBody = AttachDocumentsCommand
    export type PostApiV1VolunteersMeDocumentsMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1VolunteersMeDocuments = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1VolunteersMeDocuments>>, TError,{data: AttachDocumentsCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1VolunteersMeDocuments>>,
        TError,
        {data: AttachDocumentsCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1VolunteersMeDocumentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1VolunteersUserIdDocuments = (
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return request<VolunteerDocumentsDto>(
      {url: `/api/v1/volunteers/${userId}/documents`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1VolunteersUserIdDocumentsQueryKey = (userId?: string,) => {
    return [
    `/api/v1/volunteers/${userId}/documents`
    ] as const;
    }

    
export const getGetApiV1VolunteersUserIdDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>, TError = ProblemDetails>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1VolunteersUserIdDocumentsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>> = ({ signal }) => getApiV1VolunteersUserIdDocuments(userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1VolunteersUserIdDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>>
export type GetApiV1VolunteersUserIdDocumentsQueryError = ProblemDetails


export function useGetApiV1VolunteersUserIdDocuments<TData = Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>, TError = ProblemDetails>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>,
          TError,
          Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1VolunteersUserIdDocuments<TData = Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>, TError = ProblemDetails>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>,
          TError,
          Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1VolunteersUserIdDocuments<TData = Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>, TError = ProblemDetails>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1VolunteersUserIdDocuments<TData = Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>, TError = ProblemDetails>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1VolunteersUserIdDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1VolunteersUserIdDocumentsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




